var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportManager({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.48007 18.49V15.57C5.48007 14.6 6.24007 13.73 7.32007 13.73C8.29007 13.73 9.16007 14.49 9.16007 15.57V18.38C9.16007 20.33 7.54007 21.9501 5.59007 21.9501C3.64007 21.9501 2.02007 20.32 2.02007 18.38V12.22C1.91007 6.60005 6.35007 2.05005 11.9701 2.05005C17.5901 2.05005 22.0201 6.60005 22.0201 12.11V18.2701C22.0201 20.2201 20.4001 21.84 18.4501 21.84C16.5001 21.84 14.8801 20.2201 14.8801 18.2701V15.46C14.8801 14.49 15.6401 13.62 16.7201 13.62C17.6901 13.62 18.5601 14.38 18.5601 15.46V18.49",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.53 9.12001H14.72C14.6111 9.1212 14.5045 9.15151 14.4113 9.20778C14.3181 9.26405 14.2417 9.34423 14.19 9.44001L13.44 10.94C13.33 11.16 13.02 11.16 12.91 10.94L11.07 7.27001C10.96 7.06001 10.66 7.05001 10.55 7.26001L9.70996 8.81001C9.60996 9.00001 9.40996 9.12001 9.18996 9.12001H8.45996",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportManager);
export default __webpack_public_path__ + "static/media/support_manager.ca82aabb2c6aceedd6cb961dc9645f2b.svg";
export { ForwardRef as ReactComponent };